<template>
  <swiper
    :modules="modules"
    :slides-per-view="3.5"
    :space-between="10"
    :speed="4000"
    :loop="true"
    :autoplay="{ delay: 0, disableOnInteraction: false, reverseDirection: reverse }"
    navigation
    :pagination="{ clickable: true }"
    :scrollbar="{ draggable: true }"
    @swiper="onSwiper"
    @slideChange="onSlideChange"
  >
    <swiper-slide v-for="(item, index) in list" :key="index">
      <img :src="item.pic" alt="photo">
    </swiper-slide>
  </swiper>
</template>

<style lang="scss" scoped>
img {
  width: 100%;
  object-fit: cover;
}
</style>

<script>
import { ref, toRefs } from 'vue'
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'

export default {
  props: {
    list: {
      type: Array,
      required: true
    },
    reverse: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  setup(props) {
    const { reverse } = toRefs(props);
    const onSwiper = (swiper) => {
    }
    const onSlideChange = () => {
    }
    return {
      onSwiper,
      onSlideChange,
      modules: [Navigation, Pagination, Scrollbar, A11y, Autoplay],
      reverse,
    }
  },
}
</script>
